﻿<script>
	import { getContext } from 'svelte';

	import { fade, fly } from 'svelte/transition';
    import { onMount } from "svelte";
    import { nanoid } from "nanoid";

    import { registerPageComplete } from "../tealium";
    import { endSurveyPageIndex, pageNumber, currentPage, pageList } from '../stores/pageStore';
    import model from "../stores/modelStore";
    import lookups from "../stores/lookupStore";
	import { isValid } from "../validation";
    import SuperFund from "../models/SuperFund";

    import PageSection from "../components/PageSection.svelte"
    import NavigationButtons from "../components/NavigationButtons.svelte"
    import SuperFundDetails from "../components/SuperFundDetails.svelte"
    import Form from "../components/Form.svelte"
    import FormRow from "../components/FormRow.svelte"
    import FormColumn from "../components/FormColumn.svelte"
    import YesNoGroup from "../components/YesNoGroup.svelte"
    import Input from "../components/Input.svelte"
    import CheckboxList from "../components/CheckboxList.svelte"
    import SuperFundSelector from '../components/SuperFundSelector.svelte';

    export let disabled;
    
	const benetifOther = "DISFUND003A13"

    let initialisedSuperFunds = ($model.KnowSuperFundDetails === "True");
    let activeSuperFundIndex = 0;
	let otherSelectedBenefits = [];
	let otherBenefitRequired = false;
    
    let buttons;
    let superFundValidator;
    let otherSuperFundInitialised = false;
	const { displayError } = getContext("error-modal");
    
	onMount(() => {
        // Ensure the any Super Funds have unique Ids

        if (!$model.SuperFunds) {
            $model.SuperFunds = [new SuperFund()];
        }

        $model.SuperFunds.forEach(s => s.Id = nanoid(6));

        if (!$model.OtherClaimSuperFund) {
            $model.OtherClaimSuperFund = new SuperFund();
        }

		if ($model.OtherClaimSuperFund && $model.OtherClaimSuperFund.OtherBenefitsClaimed) {
			otherSelectedBenefits = $model.OtherClaimSuperFund.OtherBenefitsClaimed.split(",");
			otherBenefitRequired =  otherSelectedBenefits.indexOf(benetifOther) >= 0;
		}
        otherSuperFundInitialised = true;

        console.log("onMount - FundDetails");
	});

	$: {
		if (otherSuperFundInitialised) {
		    $model.OtherClaimSuperFund.OtherBenefitsClaimed = otherSelectedBenefits.join(",");
			otherBenefitRequired =  otherSelectedBenefits.indexOf(benetifOther) >= 0;

		}
        console.log("FundDetails - updating");
	}

	const handleSubmit = async (e) => {
        //e.preventDefault();
        buttons.blockNext();

		if (isValid()) {
            // Reset values as required
            if($model.KnowSuperFundDetails === "False") {
                $model.SuperFunds = [];
                $model.OtherClaimSuperFund = null;
                $model.FundDetailsScreenOut = true;
                $model.SurveyComplete = $model.FundDetailsScreenOut;

            }

			registerPageComplete("Fund Details",
				$model.Contact.EmailAddress,
				$model.Contact.PhoneNumber,
				$model.ReferralSource);

			let response = await model.saveModelAsync();

			if (!response.success) {
				console.log(displayError)
				displayError(response);
			} else {
				buttons.next();
			}
		}

        buttons.unblock();
		return true;
	};
    
    const handleFundDetailsChange = (e) => {
        if ($model.KnowSuperFundDetails === "True") {
            $model.FundDetailsScreenOut = false;
            $model.SurveyComplete = $model.FundDetailsScreenOut;

            if (!initialisedSuperFunds) {
                activeSuperFundIndex = 0

                $model.SuperFunds = [new SuperFund()];
                $model.OtherClaimSuperFund = new SuperFund();
                initialisedSuperFunds = true;
            }
        } else if ($model.KnowSuperFundDetails === "False") {
            $model.FundDetailsScreenOut = true;
            $model.SurveyComplete = $model.FundDetailsScreenOut;
        }
	};
        
    const handleSelectFund = (e) => {
        let errors = superFundValidator.validate();
        if (errors.length) return;

        activeSuperFundIndex = e.detail.newIndex;
   }
        
    const handleAddFund = () => {
        let errors = superFundValidator.validate();
        if (errors.length) return;

        $model.SuperFunds = [new SuperFund(), ...$model.SuperFunds];
        activeSuperFundIndex = 0;
   }
    
    const handleRemoveFund = (e) => {
        let index = e.detail.index;

        $model.SuperFunds.splice(index, 1);
        $model.SuperFunds = [...$model.SuperFunds];
        if (index === activeSuperFundIndex) {
            activeSuperFundIndex = $model.SuperFunds.length ? $model.SuperFunds.length - 1 : 0;
        }
   }

	if ($pageNumber == $endSurveyPageIndex) {
		window.location.href = $pageList[0].routeId;
	} else {
		$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);
	}

</script>

{#if $pageNumber == ($currentPage ? $currentPage.pageIndex : 0)}
<PageSection>

	<Form {disabled} id="find-details" on:submit={handleSubmit}>

	    <h1>Fund Details</h1>

	    <FormRow>
		    <FormColumn>
                <YesNoGroup required {disabled}
                    label="Do you know the details of your Super Fund(s) or Insurance Policy?"
                    name="knowSuperFundDetails"
                    bind:value="{$model.KnowSuperFundDetails}"
                    on:change={(e) => {handleFundDetailsChange(e)}}/>
		    </FormColumn>
	    </FormRow>

        <p>
            To find your fund details, your can use the 
            <a href="https://www.ato.gov.au/Forms/Searching-for-lost-super/" target="_blank" title="ATO Superannuation Search">ATO Superannuation Search</a>.
            Make sure you have your tax file number ready.
        </p>

        {#if $model.KnowSuperFundDetails === "True" && (initialisedSuperFunds || disabled)}

        {#if !disabled}

	        <FormRow>
		        <FormColumn cols="8">
                    {#key $model.SuperFunds[activeSuperFundIndex].Id}
                        <div
                            in:fade|local="{{ delay: 100, duration: 200 }}"
                            out:fade|local="{{ delay: 0, duration: 0 }}">
                            <SuperFundDetails
                                bind:superFund={$model.SuperFunds[activeSuperFundIndex]}
                                bind:superFundValidator={superFundValidator}></SuperFundDetails>
                        </div>
                    {/key}
		        </FormColumn>
		        <FormColumn cols="4">
                    <SuperFundSelector
                        bind:superFunds={$model.SuperFunds}
                        bind:activeSuperFundIndex={activeSuperFundIndex}
                        on:add-fund={handleAddFund}
                        on:remove-fund={(i) => handleRemoveFund(i)}
                        on:select-fund={(i) => handleSelectFund(i)}></SuperFundSelector>
		        </FormColumn>
	        </FormRow>

        {:else}
            {#each $model.SuperFunds as fund, i (fund)}
                <h2>{fund.FundNameLabel}</h2>
                <SuperFundDetails bind:superFund={fund} index={i} disabled></SuperFundDetails>
            {/each}
        {/if}

        <h3>Other Benefits</h3>

            {#if otherSuperFundInitialised}

	            <FormRow>
		            <FormColumn cols="12">
			            <YesNoGroup required {disabled}
				            label="Have you or do you intend to claim any other benefits for your injury or illness? (eg. WorkCover, Centrelink, Income protection, DVA, TAC etc.)"
				            name="claimedOtherBenefits"
				            bind:value="{$model.OtherClaimSuperFund.ClaimedOtherBenefits}" />
		            </FormColumn>
	            </FormRow>

                {#if $model.OtherClaimSuperFund.ClaimedOtherBenefits == "True"}

	                <FormRow>
		                <FormColumn cols="12">
			                <label for="benefitsOther" class="isrequired">What Benefits are you or do you intend to claim for your injury or illness?</label>
		                </FormColumn>
		                <FormColumn cols="8">
			                <CheckboxList
				                required
				                {disabled}
				                name="otherBenefitsOther"
				                options={$lookups.OtherBenefitOptions}
				                bind:selectedOptions={otherSelectedBenefits}
				                cols="6"
			                />
		                </FormColumn>
	                </FormRow>
                    
		            {#if otherBenefitRequired}
		                <FormRow>
			                <FormColumn cols="6">
				                <!--  TODO - Update to correct  value  -->
				                <Input
					                required
					                {disabled}
					                id="benefitsOther"
					                label="If Other, please specify below"
					                bind:value={$model.OtherClaimSuperFund.BenefitsOther}
					                maxlength="50"
				                />
			                </FormColumn>
		                </FormRow>
		            {/if}

                {/if}
            {/if}
        {/if}

        {#if (!disabled)}
            <div class="form-group form-row">
                <div class="col-md-12 last">
				    <NavigationButtons bind:buttons={buttons} />
                </div>
            </div>
        {/if}

    </Form>
</PageSection>
{/if}